import React from 'react';
import { withTranslation } from 'react-i18next';

import TextField from '../Form/TextField';

export const EmailForm = withTranslation()(
  ({ email, fieldErrors, buttonsDisabled, onInputChange, onSubmitEmail, t }) => (
    <form
      id="form-login-email"
      method="post"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmitEmail();
      }}
    >
      <TextField
        inputName="email"
        value={email}
        label={t('Username or email')}
        disabled={buttonsDisabled}
        error={fieldErrors.email}
        autoFocus
        onChange={(e) => e.preventDefault() || onInputChange(e.target.id, e.target.value)}
      />

      <div className="login-button-wrapper">
        <button
          id="btn-login-email"
          form="form-login-email"
          className="button btn-active"
          disabled={buttonsDisabled}
          type="submit"
        >
          {t('Continue')}
        </button>
      </div>
    </form>
  ),
);
